<template>
  <div class="toolbar-right-menu-action-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"
                 @wxcOverlayBodyClicked="cancelDialog"></wxc-overlay>
    <div class="toolbar-right-menu-action-dialog-box toolbar-right-menu-action-dialog-content">
      <div v-for="action in actions" @click="onActionSelected(action)" :key="action">
        <weex-text style="margin-top: 10px; margin-bottom: 10px">{{ action }}</weex-text>
      </div>
    </div>
  </div>
</template>

<script>
import WxcOverlay from "@/../weex-ui/packages/wxc-overlay/index"
import env from "@/utils/env";

export default {
  name: "ToolbarRightMenuActionsDialog",
  components: { WxcOverlay },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    top: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    isWeb: env.isWebPlatform(),
  }),

  methods: {
    cancelDialog() {
      this.$emit("onActionNotSelected");
    },

    onActionSelected(action) {
      this.$emit("onActionSelected", action);
    }
  }
};
</script>

<style scoped>
.toolbar-right-menu-action-dialog-container {
  position: absolute;
  z-index: 9999;
  right: 0;
}

.toolbar-right-menu-action-dialog-box {
  position: absolute;
  right: 0;
  width: 200px;
  background-color: #ffffff;
}

.toolbar-right-menu-action-dialog-content {
  padding: 10px;
}

</style>
